document.addEventListener("DOMContentLoaded", (event) => {
  const tabs = document.querySelectorAll('.recently-viewed .tabs-container input');
  if (tabs) {
      tabs.forEach(tab => {
          if (tab.checked) {
              document.querySelector('.recently-viewed .content' + tab.dataset.tab).style.display = 'block';
          }
          tab.addEventListener('change', (e) => {
              let contents = document.querySelectorAll('.recently-viewed .tab');
              contents.forEach(content => {
                  content.style.display = 'none';
              })
              document.querySelector('.recently-viewed .content' + tab.dataset.tab).style.display = 'block';
          })
      })
  }
});

const recently_viewed_section = document.querySelector('.recently-viewed');

const options = {
	rootMargin: '100px'
}

const observer = new IntersectionObserver(entry => {

    if (entry[0].isIntersecting == true) {

        observer.unobserve(recently_viewed_section)
    
        let rec_prods = localStorage.getItem(window.Shopify.shop.replace(/.myshopify.com/g,'') + 'recentlyViewedProductHandles');
        if (rec_prods) {
            rec_prods_arr = rec_prods.replace("[","").replace("]","").split(',');
            
            let recently_viewed = document.querySelector('.recently-viewed-slider');
            
            rec_prods_arr.forEach(rec_prod => {
                let handle = rec_prod.replace(/"/g,'');
        
                fetch(window.Shopify.routes.root + `products/${handle}?view=card&section_id=gt-product-card`)
                  .then(response => {
                    if (response.ok) {
                      return response.text();
                    } else {
                      throw new Error("Error: " + response.status);
                    }
                  })
                  .then(data => {
                    const htmlDocument = new DOMParser().parseFromString(data, "text/html");
                    const productCard = htmlDocument.documentElement.querySelector(".gt-product-card");
                    const productTitle = productCard.querySelector(".product-title");
                    if (productTitle.innerHTML !== "") {
                      let url = window.location.href + "#";
                      let swiper_slide = document.createElement("div");
                      swiper_slide.classList.add('swiper-slide');
                      swiper_slide.insertAdjacentHTML('afterbegin', productCard.outerHTML);

                      if (productCard !== url) {
                        recently_viewed.insertAdjacentHTML('afterbegin', swiper_slide.outerHTML);
                      }
                    }

                    const recent_swiper = new window.swiper('.recently-swiper', {
                      slidesPerView: 1.5,
                      spaceBetween: 20,
                      breakpoints: {
                        768: {
                          slidesPerView: 2,
                          spaceBetween: 30,
                        },
                        1028: {
                          slidesPerView: 3,
                          spaceBetween: 30,
                        },
                        1280: {
                          slidesPerView: 4,
                          spaceBetween: 30,
                        },
                      },
                      navigation: {
                        nextEl: '.recently-swiper-button-next',
                        prevEl: '.recently-swiper-button-prev',
                      },
                    });
                  
                    window.globalListeners.hideEmptyCardReview();
                    window.globalListeners.hideEmptyPDPReview();

                    
                  })
                  .catch(error => {
                    console.error(error);
                  });

            });
            
        } else {
            document.querySelector('.recently-viewed label[for="tab2"]').style.paddingRight = '0';
            document.querySelector('.recently-viewed #tab2').style.display = 'none';
            document.querySelector('.recently-viewed label[for="tab2"]').style.display = 'none';
        }

        // Init section settings collection swiper
        const coll_swiper = new window.swiper('.best-sellers-swiper', {
            slidesPerView: 1.5,
            spaceBetween: 20,
            breakpoints: {
              768: {
                slidesPerView: 2,
                spaceBetween: 30,
              },
              1028: {
                slidesPerView: 3,
                spaceBetween: 30,
              },
              1280: {
                slidesPerView: 4,
                spaceBetween: 30,
              },
            },
            navigation: {
              nextEl: '.bestsellers-swiper-button-next',
              prevEl: '.bestsellers-swiper-button-prev',
            },
        });
    }

  
}, options)

observer.observe(recently_viewed_section)